import UserEvents from './UserEvents';

export default UserEvents;
